import Home from "./components/Home";
import Mybeats from "./components/Mybeats";
import Join from "./components/Join";
import Help from "./components/Help";
import Search from "./components/Search";
import Settings from "./components/Settings";
import Tomusic from "./components/Tomusic";
import Playroom from "./components/Playroom";
import Playhouse from "./components/Playhouse";
import Music from "./components/Music";
import Chatpage from "./components/Chatpage";
import Chatroom from "./components/Chatroom";
import Bottomnav from "./components/Bottomnav";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

function App() {
  const phone = localStorage.getItem("user-phone");

  return (
    <Router>
      <div className="home page">
        <Routes>
          <Route
            path="/"
            element={<>{phone !== null ? <Home /> : <Join />}</>}
          />
          <Route path="/Mybeats" element={<Mybeats />} />
          <Route path="/Music" element={<Music />} />
          <Route path="/Playhouse" element={<Playhouse />} />
          <Route path="/Playroom" element={<Playroom />} />
          <Route path="/Chatpage" element={<Chatpage />} />
          <Route path="/Chatroom" element={<Chatroom />} />
          <Route path="/Search" element={<Search />} />
          <Route path="/Settings" element={<Settings />} />
          <Route path="/Help" element={<Help />} />
          <Route path="/join" element={<Join />} />
        </Routes>
      </div>
      <Bottomnav />
    </Router>
  );
}

export default App;
